import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
};

const AlbumFolderGalleryIcon = ({
  color = '#cdd6e3',
  size = '45',
  id = 'album-folder-gallery-icon',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    link="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M12.88 0C13.51 0 14 .492 14 1.054v11.884c0 .562-.49 1.054-1.05 1.054l-11.9.001c-.56.07-1.05-.421-1.05-.985V1.055C0 .492.49 0 1.05 0h11.83z"
        id={`${id}-a`}
      />
      <path
        d="M12.945 0C13.578 0 14 .492 14 1.054v11.884c0 .562-.492 1.054-1.055 1.054l-11.89.001C.492 14.063 0 13.572 0 13.01V1.056C0 .492.492 0 1.055 0h11.89z"
        id={`${id}-c`}
      />
      <path
        d="M12.945 0C13.578 0 14 .492 14 1.055v11.889c0 .563-.492 1.055-1.055 1.055L1.056 14a1.035 1.035 0 0 1-1.055-1.055L0 1.056C0 .492.492 0 1.056 0h11.89z"
        id={`${id}-e`}
      />
      <path
        d="M12.88 0C13.51 0 14 .492 14 1.055v11.889c0 .563-.49 1.055-1.05 1.055L1.05 14c-.63 0-1.049-.492-1.049-1.055L0 1.055C0 .492.49 0 1.05 0h11.83z"
        id={`${id}-g`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        mask={`url(#${id}-b)`}
        d="M-3.684-3.684h21.368v21.368H-3.684z"
      />
      <g transform="translate(0 18)">
        <mask id={`${id}-d`} fill="#fff">
          <use xlinkHref={`#${id}-c`} />
        </mask>
        <path
          fill={color}
          mask={`url(#${id}-d)`}
          d="M-3.684-3.684h21.368v21.368H-3.684z"
        />
      </g>
      <g transform="translate(18 18)">
        <mask id={`${id}-f`} fill="#fff">
          <use xlinkHref={`#${id}-e`} />
        </mask>
        <path
          fill={color}
          mask={`url(#${id}-f)`}
          d="M-3.684-3.684h21.368v21.368H-3.684z"
        />
      </g>
      <g transform="translate(18)">
        <mask id={`${id}-h`} fill="#fff">
          <use xlinkHref={`#${id}-g`} />
        </mask>
        <path
          fill={color}
          mask={`url(#${id}-h)`}
          d="M-3.684-3.684h21.368v21.368H-3.684z"
        />
      </g>
    </g>
  </svg>
);

AlbumFolderGalleryIcon.propTypes = propTypes;

export default AlbumFolderGalleryIcon;
